// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "img[data-v-0cb6f08a]{max-height:200px}@media (max-width:575px){.btn[data-v-0cb6f08a]{display:block;width:100%}}", ""]);
// Exports
module.exports = exports;
